/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
import Tab from '@/components/Base/Tab.vue';
import { mapMutations, mapState } from 'vuex';
import { getid } from '@/api';
export default {
  name: 'app',
  components: {
    Tab: Tab,
    ConnectAdmin: function ConnectAdmin() {
      return import('./components/ConnectAdmin');
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    isShowConnectAdmin: function isShowConnectAdmin() {
      return this.user.isPresonal === 1 && process.env.NODE_ENV === 'production';
    }
  }),
  created: function created() {
    this.getPrams();
  },
  mounted: function mounted() {
    // 适配Android手机
    if (window.RUN_ENV === 'Android') {
      var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      var htmlDom = document.getElementsByTagName('html')[0];
      htmlDom.style.fontSize = htmlWidth / 30 + 'px';
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_user', '_RUN_ENV', '_sysPhone'])), {}, {
    getPrams: function getPrams() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var code, data, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                code = new URLSearchParams(location.search).get('code') || '';

                if (code) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                data = {
                  code: code
                };
                _context.next = 7;
                return getid(data);

              case 7:
                res = _context.sent;

                if (res.data.code == 0) {
                  localStorage.setItem('id', res.data.production.id);
                  localStorage.setItem('code', res.data.production.code);
                  localStorage.setItem('viewSecondaryDrawings', res.data.production.viewSecondaryDrawings);
                } else {
                  _this.$vux.toast.text(res.data.msg);

                  localStorage.setItem('id', '');
                  localStorage.setItem('code', '');
                  localStorage.setItem('viewSecondaryDrawings', false);
                }

                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }))();
    }
  })
};